export default __webpack_public_path__ + "static/media/rating_icon.965258b4.svg";